export default __webpack_public_path__ + "static/media/grid-settings.21408ecd.md";